/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Content.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import DownloadAllCSV from './DownloadAllCSV/logic.js'
import DownloadCSV from './DownloadCSV/view.js'
import React from 'react'
import useIsBefore from 'Logic/useIsBefore.js'
import { css } from "emotion"
DownloadAllCSV.displayName = 'DownloadAllCSVLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  transformOrigin: "top left",
position: "absolute",
zIndex: 1,
backgroundColor: "#ffffff",
borderBottomLeftRadius: 5,
borderBottomRightRadius: 5,
borderTopLeftRadius: 5,
borderTopRightRadius: 5,
paddingTop: 4,
paddingLeft: 4,
paddingRight: 4,
paddingBottom: 4,
boxShadow: "0px 4px 20px 0px rgba(109, 109, 109, 0.2)",
  
transition: 'opacity 50ms ease-out, transform 60ms ease-out',
willChange: 'opacity, transform',
  opacity: 'var(--opacity)',
transform: 'translateY(var(--translateY))',
top: 'var(--top)',
left: 'var(--left)',
width: 'var(--width)'})

export default function Content({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  top= 32,
left= 0,
width= 220,
hasSelected,
viewPath= "/App/MyAccount/Content/Members/MoreActions/Content"
}) {
    let isBefore = useIsBefore()
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="Content.Vertical"
 data-view-path="/App/MyAccount/Content/Members/MoreActions/Content"
 style={{'--top': typeof top === 'number' ? `${top}px` : top,'--left': typeof left === 'number' ? `${left}px` : left,'--width': typeof width === 'number' ? `${width}px` : width,'--opacity': isBefore ? 0 : 1,'--translateY': isBefore ? "-10px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
{
hasSelected ? 
<DownloadCSV
 data-testid="Content.DownloadCSV"
 data-view-path="/App/MyAccount/Content/Members/MoreActions/Content"
viewPath={`${viewPath}/DownloadCSV`}
/>
 : null
}
<DownloadAllCSV
 data-testid="Content.DownloadAllCSV"
 data-view-path="/App/MyAccount/Content/Members/MoreActions/Content"
viewPath={`${viewPath}/DownloadAllCSV`}
/>
</div>
{children}
</React.Fragment>)
}